export const capitalizar = (str) => {
  return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : ''
}
